import { useParams } from 'react-router-dom';
import { PageHeader } from '../common';
import { StartPanel } from './StartPanel';
import { SessionView } from './SessionView';

/**
 * Deploy page. Without an id: start a deployment (Guardian worklist or manual).
 * With an id: the persisted deployment session — resumable after a refresh or by another engineer.
 */
export function DeploymentWizard() {
  const { deploymentId } = useParams();
  return (
    <>
      <PageHeader title="Deploy" description="Install a licensed FirstIQ product into a customer's Microsoft 365 tenant." />
      {deploymentId ? <SessionView id={deploymentId} /> : <StartPanel />}
    </>
  );
}
